import { createSelector } from 'reselect';
import * as R from 'ramda';
import S from 'common/service/sanctuary';

export const getQuery = ({ query }) => query;

export const getSearch = ({ search }) => search;

const includes = query => value => (R.is(String, value) ?
  value.toLowerCase().includes(query) :
  R.toString(value).toLowerCase().includes(query));

const hasQuery = query => data => R.compose(
  R.reduce(R.or, false),
  R.map(R.ifElse(R.is(Object), hasQuery(query), includes(query))),
  R.filter(R.compose(R.not, R.isNil)),
  R.values,
)(data);

export const localSearch = createSelector(
  getQuery,
  (query = '') => (R.isNil(query)
    ? S.I
    : S.filter(hasQuery(S.toLower(query)))
  ),
);

export const factory = getScope => ({
  getQuery: createSelector(
    getScope,
    getQuery,
  ),
  getSearch: createSelector(
    getScope,
    getSearch,
  ),
  localSearch: createSelector(
    getScope,
    localSearch,
  ),
});

export default factory;
